<template>
  <div>
    <div class="mt-5">
      <div class="columns">
        <div class="column">
          <p :class="['title mb-1', currentTheme === 'dark' ? 'has-text-white' : '']">Withdraw</p>
          <p class="has-text-grey">Withdraw your assets or CMTY tokens</p>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-3">
        <div :class="['box has-background-dark top-card', currentTheme === 'dark' ? 'has-text-black' : 'has-text-white']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-1">
              Total Supply: 10B CMTY
            </p>
            <p style="font-size: 0.95rem;">
              TVL: <span class="has-text-weight-bold">{{ formatTVL(totalValueLocked) }}</span> <span class="has-text-grey">CMTY</span>
            </p>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">User Balance</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Balance</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ userTokenBalance }}</span>
                <span class="ml-1">CMTY</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3" v-if="userNftId">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">NFT ID: #{{ userNftId }}</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Total Deposits</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(userNftBalance) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">Available for Withdraw</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Max</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(maxWithdrawalAmount) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box m-5">
      <div class="columns">
        <div class="column">

          <!--
            <vue-countdown class="has-text-danger" v-if="counting" :time="60000" @end="onCountdownEnd" v-slot="{ totalSeconds }">The page will refresh automatically in <strong>{{ totalSeconds }}</strong> seconds</vue-countdown>
          -->

          <table class="table is-striped table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>Cyclos ID</th>
                <th>Amount</th>
                <th>Max. Available<br>for Withdrawals</th>
                <th>Withdrawals</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in depositList" :key="x.txID">
                <td>{{ x.cyclosID }}</td>
                <td>
                  <div class="tags has-addons">
                    <span class="tag is-dark">CMTY</span>
                    <span class="tag is-info">
                      {{ Number(x.amount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="tags has-addons">
                    <span class="tag is-dark">CMTY</span>
                    <span class="tag is-info" v-if="x.finished!='Processed'">
                      {{ Number(x.maxAvailable).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>
                    <span class="tag is-info" v-if="x.finished=='Processed'">
                      0
                    </span>
                  </div>
                </td>
                <td>
                  <div v-if="x.withdrawals && x.withdrawals.length > 0">
                    <div v-for="(w, idx) in x.withdrawals" :key="idx" class="mb-1">
                      <div class="tags has-addons">
                        <span class="tag is-dark is-small">CMTY</span>
                        <span class="tag is-success is-small">
                          {{ Number(w.amount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <span v-else class="has-text-grey-light is-size-7">No withdrawals yet</span>
                </td>
                <td v-if="x.finished=='Processed'">
                  <span class="tag is-info">{{ x.finished }}</span>
                </td>
                <td v-if="x.finished!='Processed'">
                  <button @click="handleWithdraw(x)" :disabled="x.maxAvailable <= 0" class="button is-dark is-small">Withdraw</button>
                </td>
              </tr>

              <tr v-if="depositList.length == 0">
                <td colspan="5">There are no transactions yet</td>
              </tr>
            </tbody>
            <tfoot v-if="depositList.length > 0">
              <tr>
                <th>Total</th>
                <th>
                  <div class="tags has-addons">
                    <span class="tag is-dark">CMTY</span>
                    <span class="tag is-info has-text-weight-bold">
                      {{ totalAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>
                  </div>
                </th>
                <th></th>
                <th>
                  <div class="tags has-addons">
                    <span class="tag is-dark">CMTY</span>
                    <span class="tag is-success has-text-weight-bold">
                      {{ totalWithdrawals.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                    </span>
                  </div>
                </th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from "@/utilities/util.js";
import Web3 from "web3";

export default {
  name: "WithdrawPage",
  data() {
    return {
      currentTheme: localStorage.getItem('theme') || 'light',
      isConnected: false,
      account: null,
      web3: new Web3(window.ethereum),
      depositList: [],
      counting: false,
      nftImage: require('@/assets/nft.png'),
      vaultImage: require('@/assets/vault.png'),
      walletImage: require('@/assets/wallet.png'),
      userTokenBalance: 0,
      userNftId: null,
      userNftBalance: 0,
      maxWithdrawalAmount: 0,
      totalValueLocked: 0,
    };
  },
  created() {
    window.addEventListener('storage', this.handleThemeChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleThemeChange);
  },
  computed: {
    totalAmount() {
      return this.depositList.reduce((sum, deposit) => {
        return sum + Number(deposit.amount);
      }, 0);
    },
    totalWithdrawals() {
      return this.depositList.reduce((sum, deposit) => {
        if (deposit.withdrawals && deposit.withdrawals.length > 0) {
          const depositWithdrawalsSum = deposit.withdrawals.reduce((wSum, w) => {
            return wSum + Number(w.amount);
          }, 0);
          return sum + depositWithdrawalsSum;
        }
        return sum;
      }, 0);
    }
  },
  async mounted() {
    this.$watch(
      () => {
        return this.$store.state.isConnected;
      },
      (val) => {
        this.isConnected = val;
      }
    );

    await util.reconnect();
    this.$store.commit("changeConnectionStatus", true);
    this.account = await util.getCoinbase();
    this.$store.commit("changeAccount", this.account);

    this.tokenContract = await util.tokenContractInstance();
    this.orchestratorContract = await util.OrchestratorContractInstance();
    this.oracleContract = await util.OracleContractInstance();
    this.nftContractInstance = await util.NFTContractInstance();
    
    await this.loadHeaderData();
    this.getDeposits();
    this.startCountdown();
  },
  methods: {
    handleThemeChange(event) {
      if (event.key === 'theme') {
        this.currentTheme = event.newValue;
      }
    },
    formatNFTBalance(balance) {
      if (!balance) return '0';
      try {
        const decimalValue = util.subtractDecimals(balance, 18);
        const roundedValue = Math.round(parseFloat(decimalValue));
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting balance:', error);
        return '0';
      }
    },
    numberFormat(number) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(number);
    },
    async loadHeaderData() {
      try {
        this.userTokenBalance = this.numberFormat(util.subtractDecimals(
          await this.tokenContract.methods.balanceOf(this.account).call(), 18
        ));
        
        this.userNftId = await this.nftContractInstance.methods.getUserToken(this.account).call();
        
        if (this.userNftId && this.userNftId !== '0') {
          const balance = await this.nftContractInstance.methods.balanceOf(this.account, this.userNftId).call();
          this.userNftBalance = balance;
        }
        
        // Get max withdrawal amount
        const maxWithdrawal = await this.orchestratorContract.methods.getMaxWithdrawalAmount(this.account).call();
        this.maxWithdrawalAmount = maxWithdrawal;
        
        // Get total value locked from Orchestrator
        const tvl = await this.orchestratorContract.methods.totalAssets().call();
        this.totalValueLocked = tvl;
      } catch (error) {
        console.error('Error loading header data:', error);
      }
    },
    formatTVL(tvl) {
      if (!tvl) return '0';
      try {
        const decimalValue = util.subtractDecimals(tvl, 18);
        const roundedValue = Math.round(parseFloat(decimalValue));
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting TVL:', error);
        return '0';
      }
    },
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
      this.getDeposits();
      setTimeout(() => {
        this.startCountdown();
      }, 100);
    },
    async getDeposits() {
      this.depositList = [];

      const maxAmount = await this.orchestratorContract.methods
        .getMaxWithdrawalAmount(this.account)
        .call();
      const maxAmountInCMTY = util.subtractDecimals(maxAmount, 18);

      const txCount = await this.oracleContract.methods
        .txsCount(this.account)
        .call();

      // Get ToChainTransactionAdded events to extract the correct amount
      const depositEvents = await this.oracleContract.getPastEvents('ToChainTransactionAdded', {
        filter: { user: this.account },
        fromBlock: 0,
        toBlock: 'latest'
      });

      // Create a map of cyclosID -> amount for quick lookup
      const amountMap = {};
      for (const event of depositEvents) {
        const cyclosID = event.returnValues.cyclosID;
        const amount = util.subtractDecimals(event.returnValues.amount, 18);
        amountMap[cyclosID] = amount;
      }

      // Get Withdraw events to show withdrawal history
      const withdrawEvents = await this.orchestratorContract.getPastEvents('Withdraw', {
        filter: { user: this.account },
        fromBlock: 0,
        toBlock: 'latest'
      });

      // Create a map of cyclosID -> array of withdrawals
      const withdrawalsMap = {};
      for (const event of withdrawEvents) {
        const cyclosID = event.returnValues.cyclosId;
        const amount = util.subtractDecimals(event.returnValues.amount, 18);
        const blockNumber = event.blockNumber;
        
        if (!withdrawalsMap[cyclosID]) {
          withdrawalsMap[cyclosID] = [];
        }
        withdrawalsMap[cyclosID].push({
          amount: amount,
          blockNumber: blockNumber,
          txHash: event.transactionHash
        });
      }

      for (let i = 0; i < txCount; i++) {
        const tx = await this.oracleContract.methods
          .txsPerUser(this.account, i)
          .call();
        if (!tx.toCyclos) {
          // Get amount from event instead of storage (storage may have 0)
          const txAmount = amountMap[tx.cyclosID] || util.subtractDecimals(tx.amount, 18);
          const withdrawals = withdrawalsMap[tx.cyclosID] || [];
          const status = tx.finished ? "Processed" : "Pending";
          
          // Calculate sum of all withdrawals for this deposit
          const totalWithdrawn = withdrawals.reduce((sum, w) => sum + Number(w.amount), 0);
          
          // Calculate maxAvailable with exceptions
          let maxAvailable = 0;
          if (status === "Processed") {
            // Exception 1: If status is "Processed", maxAvailable is always 0
            maxAvailable = 0;
          } else {
            // Calculate: amount - sum of withdrawals
            const calculated = Number(txAmount) - totalWithdrawn;
            // Exception 2: If calculated > getMaxWithdrawalAmount, use getMaxWithdrawalAmount
            maxAvailable = Math.min(calculated, Number(maxAmountInCMTY));
          }
          
          this.depositList.push({
            txID: i,
            cyclosID: tx.cyclosID,
            amount: txAmount,
            maxAvailable: maxAvailable,
            finished: status,
            withdrawals: withdrawals
          });
        }
      }
    },
    async handleWithdraw(tx) {
      try {
        // Use the calculated maxAvailable from the tx object (already in CMTY units)
        // Use Web3.utils.toWei to properly handle BigNumber conversion
        const withdrawAmount = window.myWeb3.utils.toWei(tx.maxAvailable.toString(), 'ether');
        this.executeWithdraw(tx.txID, withdrawAmount);
      } catch (error) {
        console.error('Error processing withdrawal:', error);
        util.toast.fire({ icon: "error", title: "Error processing withdrawal" });
      }
    },

    executeWithdraw(txID, amount) {
      let loader = this.$loading.show({});
      
      // Estimar gas para withdraw
      this.orchestratorContract.methods
        .withdraw(txID, amount)
        .estimateGas({ from: this.account })
        .then(async (estimatedGas) => {
          const gasLimitWithBuffer = estimatedGas * util.GAS_MULTIPLIER;

          // Obtener gas price actual de la red
          const gasPrice = await this.web3.eth.getGasPrice();
          const gasPriceWithBuffer = BigInt(gasPrice) * BigInt(util.PRICE_MULTIPLIER); // 4x para inclusión rápida
          
          console.log(`GAS_MULTIPLIER: ${util.GAS_MULTIPLIER.toString()}`);
          console.log(`PRICE_MULTIPLIER: ${util.PRICE_MULTIPLIER.toString()}`);
          console.log(`Estimated gas: ${estimatedGas.toString()}`);
          console.log(`Gas limit (with buffer): ${gasLimitWithBuffer.toString()}`);
          console.log(`Gas price: ${this.web3.utils.fromWei(gasPrice.toString(), 'gwei')} gwei`);

          this.orchestratorContract.methods
            .withdraw(txID, amount)
            .send({ from: this.account, gas: gasLimitWithBuffer, gasPrice: gasPriceWithBuffer.toString() })
            .on("receipt", async (receipt) => {
              this.getDeposits();
              loader.hide();
              util.toast.fire({ icon: "success", title: "withdraw completed" });
            })
            .on("error", (error) => {
              loader.hide();
              console.log(error);
              util.toast.fire({ icon: "error", title: "transaction error" });
            });
        })
        .catch((error) => {
          loader.hide();
          console.log(error);
          util.toast.fire({ icon: "error", title: "gas estimation error" });
        });
    },
  },
};
</script>

<style scoped>
.nft-id-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nft-id-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.nft-id-card.is-dark p {
  color: #fff;
}

.nft-id-card img {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.balance-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12),
              0 12px 24px rgba(0, 0, 0, 0.12);
}

.balance-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.balance-card.is-dark p {
  color: #fff;
}

.balance-card img {
  border-radius: 4px;
}

.top-card {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
}
</style>
